import { z } from "zod";
import { type WidgetModule, type WidgetRenderContext } from "@salestrak/ui";
import { IssueViewProperties } from "#app/components/issue-view/issue-view-properties";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";

export const issuePropertiesConfigSchema = z.looseObject({});
export type IssuePropertiesConfig = z.infer<typeof issuePropertiesConfigSchema>;

function IssuePropertiesRender(_: WidgetRenderContext<IssuePropertiesConfig>) {
  const ctx = useIssueWidgetContext();
  return (
    <IssueViewProperties
      issue={ctx.issue}
      stage={ctx.stage}
      workflowId={ctx.workflowId}
      address={ctx.address}
      assignees={ctx.assignees}
      issueTypes={ctx.issueTypes}
      issueTypeId={ctx.issue?.issueTypeId}
      onIssueTypeChange={ctx.onIssueTypeChange}
    />
  );
}

export const issuePropertiesDef: WidgetModule<IssuePropertiesConfig> = {
  type: "issue-properties",
  title: "Properties",
  icon: "list",
  span: { minW: 3, minH: 1, maxW: 12, maxH: 12, defaultW: 12, defaultH: 2 },
  configSchema: issuePropertiesConfigSchema,
  render: IssuePropertiesRender,
};
